__turbopack_context__.v({
  "autocomplete-wrapper": "UVuAaW_autocomplete-wrapper",
  "camera-button": "UVuAaW_camera-button",
  "camera-icon-svg": "UVuAaW_camera-icon-svg",
  "cross-mobile-icon": "UVuAaW_cross-mobile-icon",
  "icon-container": "UVuAaW_icon-container",
  "input": "UVuAaW_input",
  "input--no-camera": "UVuAaW_input--no-camera",
  "lens-icon-container": "UVuAaW_lens-icon-container",
  "lens-icon-container--solo": "UVuAaW_lens-icon-container--solo",
  "searchCard": "UVuAaW_searchCard",
  "searchCardClose": "UVuAaW_searchCardClose",
  "searchCardField": "UVuAaW_searchCardField",
  "searchCardInner": "UVuAaW_searchCardInner",
  "searchCardInput": "UVuAaW_searchCardInput",
  "searchCardLens": "UVuAaW_searchCardLens",
  "searchCardRow": "UVuAaW_searchCardRow",
  "searchSheet": "UVuAaW_searchSheet",
  "searchSheetBarcode": "UVuAaW_searchSheetBarcode",
  "searchSheetCamera": "UVuAaW_searchSheetCamera",
  "searchSheetField": "UVuAaW_searchSheetField",
  "searchSheetInput": "UVuAaW_searchSheetInput",
  "searchSheetLens": "UVuAaW_searchSheetLens",
  "searchSheetRow": "UVuAaW_searchSheetRow",
  "searchTrigger": "UVuAaW_searchTrigger",
  "searchbar-main": "UVuAaW_searchbar-main",
  "visual-search-input": "UVuAaW_visual-search-input",
  "visual-source": "UVuAaW_visual-source",
  "visual-source-backdrop": "UVuAaW_visual-source-backdrop",
  "visual-source-cancel": "UVuAaW_visual-source-cancel",
  "visual-source-option": "UVuAaW_visual-source-option",
  "visual-source-sheet": "UVuAaW_visual-source-sheet",
  "visual-source-title": "UVuAaW_visual-source-title",
});
